import { useSearchParams } from "react-router";

export const useArticleModalState = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const articleSlug = searchParams.get("articleModal");
  const isArticleModalOpen = !!articleSlug;
  const setIsArticleModalOpen = (slug: string | false) => {
    const newParams = new URLSearchParams(searchParams);

    if (typeof slug === "string") {
      newParams.set("articleModal", slug ?? "");
    } else {
      newParams.delete("articleModal");
    }

    setSearchParams(newParams, { preventScrollReset: true });
  };

  return { isArticleModalOpen, setIsArticleModalOpen, articleSlug };
};
